module.exports = __webpack_public_path__ + "static/media/01_sognolucido.4873199d.jpg";